module.exports = __webpack_public_path__ + "static/media/icon-email.544f017b.svg";